import { Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { SET_ACTIVITY_LOGS } from '@/store/mutation_types';
import { GET_ACTIVITY_LOGS } from '@/store/action_types';
import ActivityLog, { GetActivityLogs } from '@/services/activity_log';

// Each load is numbered: switching the filter or page while one is in flight
// must not let the older answer land on top of the newer one.
let activityLogsRequestId = 0;

const activityLog: Module<any, {}> = {
  state: {
    activityLogs: {
      data: null,
      metaData: null,
      isLoading: false,
      // The last load failed (the list shows a retry, not "no activity").
      failed: false,
    },
  },
  getters: {
    activityLogs: (state: { activityLogs: any }) => state.activityLogs,
  },
  mutations: {
    [SET_ACTIVITY_LOGS]: (state: { activityLogs: any }, payload: any) => {
      state.activityLogs = { ...state.activityLogs, ...payload };
    },
  },
  actions: {
    [GET_ACTIVITY_LOGS]: async ({ commit }: any, payload: GetActivityLogs) => {
      const requestId = ++activityLogsRequestId;
      commit(SET_ACTIVITY_LOGS, { isLoading: true, failed: false });

      const result: AxiosResponse = await ActivityLog.getActivityLogs(payload);

      if (requestId !== activityLogsRequestId) return false;

      if (result && result.data.status) {
        commit(SET_ACTIVITY_LOGS, {
          data: result.data.data,
          metaData: result.data.metaData,
          isLoading: false,
          failed: false,
        });
        return true;
      }

      commit(SET_ACTIVITY_LOGS, { isLoading: false, failed: true });
      return false;
    },
  },
};

export default activityLog;
